import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/layout';
// import Box from 'components/box';
// import Title from 'components/title';
// import Gallery from 'components/gallery';
// import IOExample from 'components/io-example';
import HeaderJumbotron from 'components/headerJumbotron';
import BookingInputBox from 'components/bookingInputBox';
import IconSection from 'components/iconSection';
import ZetaSection from 'components/zetaSection';
import RoomsBox from 'components/roomsBox';
import MapsSection from 'components/mapsSection';
import Footer from 'components/footer';
import { graphql } from 'gatsby';
import SEO from 'components/seo/index';

const jsonLD = {
  "@context": "http://schema.org",
  "@type": "Hotel",
  "name": "Hotel Grace Galaxy - Bandra West",
  "description": `Hotel Grace Galaxy is the best hotel in bandra west in it's class, known for it's prime location and friendly staff`,
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "IN",
    "addressLocality": "Bandra",
    "addressRegion": "Mumbai",
    "postalCode": "400050",
    "streetAddress": "SV Road, Near Shoppers Stop, Bandra West"
  },
  "image": "https://hotelgracegalaxy.com/premium-hotel-room-bandra-mumbai.jpg",
  "telephone": "+91 77-188-00-522",
  "starRating": {
    "@type": "Rating",
    "ratingValue": "4"
  },
  "priceRange": "Rs.2500 - Rs.7000",
  "checkinTime": "12:30:00",
  "checkoutTime": "11:30:00"
}
const basicSEO = {
  title: "Hotel in Bandra west, Mumbai. clean - affordable rooms with view, bathtub and more",
  description: "Best hotel in bandra west in it's class, known for prime location, clean rooms and friendly staff. Near Lilavati hospital, holy family hospital, tata memorial hospital",
  canonical: "https://hotelgracegalaxy.com/"
}
const Index = ({ data }) => (
  <Layout>
    <SEO basicSEO={basicSEO} jsonLD={jsonLD} />
    <HeaderJumbotron jumboImage={data.royalRoom} headerText="Comfortable stay, at the heart of Mumbai" />
    <BookingInputBox />
    <IconSection title="Get the best rates online at HotelGraceGalaxy.com" />
    <RoomsBox />
    <ZetaSection />
    <MapsSection />
    <Footer />
  </Layout>
);

Index.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Index;

export const query = graphql`
  query {
    rgsl: file(
      relativePath: { eq: "images/gallery/rajiv-gandhi-sea-link.jpg" }
    ) {
      childImageSharp {
        fluid(maxHeight: 500, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    royalRoom: file(
              relativePath: {
                eq: "images/gallery/royal-hotel-room-bandra-mumbai.jpg"
              }
            ) 
            {
              childImageSharp {
                fluid(maxHeight: 500, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
    bwsl: file(
      relativePath: { eq: "images/gallery/bandra-worli-sea-link.jpg" }
    ) {
      childImageSharp {
        fluid(maxHeight: 500, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    concept: file(relativePath: { eq: "images/gallery/concept.jpg" }) {
      childImageSharp {
        fluid(maxHeight: 500, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    file(relativePath: { eq: "images/gallery/bandra-worli-sea-link.jpg" }) {
      childImageSharp {
        fluid(maxHeight: 500, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    homeJson {
      title
      content {
        childMarkdownRemark {
          html
          rawMarkdownBody
        }
      }
      gallery {
        title
        copy
        image {
          childImageSharp {
            fluid(maxHeight: 500, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;
